"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleCard = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var useStyles = core_1.makeStyles(function (theme) {
    var moduleIcon = theme.variables.palette.modulePanel.moduleIcon;
    return {
        moduleCard: {
            padding: theme.spacing(4),
        },
        listItemAvatar: {
            minWidth: 'auto',
            marginRight: theme.spacing(3),
        },
        avatar: {
            background: moduleIcon.background,
            height: 24,
            width: 24,
        },
        avatarText: {
            color: moduleIcon.color,
            fontWeight: 700,
            fontSize: 22,
            fontVariant: 'small-caps',
            background: moduleIcon.colorGradient,
            '-webkit-background-clip': 'text',
            '-webkit-text-fill-color': 'transparent',
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
        },
    };
});
var ModuleCard = function (props) {
    var label = props.label, link = props.link;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.ListItem, { component: "a", href: link, button: true, className: classes.moduleCard },
        react_1.default.createElement(core_1.ListItemAvatar, { className: classes.listItemAvatar },
            react_1.default.createElement(core_1.Avatar, { variant: "square", className: classes.avatar },
                react_1.default.createElement("span", { className: classes.avatarText }, label[0]))),
        react_1.default.createElement(core_1.ListItemText, { primaryTypographyProps: { className: classes.title } }, label)));
};
exports.ModuleCard = ModuleCard;
